const React = window.React;
import PropTypes from 'prop-types';

import Player from './player';
import Song from './song';

class Playlist extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      current: {
        song: null,
        track: null,
        collapsed: null,
        listen: false
      },
      dictation: props.dictation,
      first_reading: props.first_reading,
      proof_reading: props.proof_reading
    };

    this.toggleListening = this.toggleListening.bind(this);
    this.replay = this.replay.bind(this);
    this.onCollapse = this.onCollapse.bind(this);
    this.onLoadedMetadata = this.onLoadedMetadata.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onListen = this.onListen.bind(this);
    this.onEnded = this.onEnded.bind(this);
    this.setCurrentTime = this.setCurrentTime.bind(this);
    this.play = this.play.bind(this);
    this.playPause = this.playPause.bind(this);
    this.pause = this.pause.bind(this);
    this.prev = this.prev.bind(this);
    this.next = this.next.bind(this);
    this.handleKeyBinding = this.handleKeyBinding.bind(this);
  }

  componentDidMount = () => {
    document.addEventListener("keydown", this.handleKeyBinding);
  }

  componentWillUnmount = () => {
    document.removeEventListener("keydown", this.handleKeyBinding);
  }

  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.dictation !== this.state.dictation) {
      this.setState({
        dictation: nextProps.dictation
      });
    }
  }

  handleKeyBinding = event => {
    if (document.querySelector('.js-sign-in-modal') || !document.body.contains(this.refs.playlist)) return;

    var keyCode = event.keyCode;
    if (keyCode == 13) { // Play / pause : Enter
      this.playPause();
      event.stopPropagation();
      event.preventDefault();
    } else if (keyCode == 117) { // Prev : F6
      this.prev();
      event.stopPropagation();
      event.preventDefault();
    } else if (keyCode == 9 || keyCode == 118) { // Next : Tab / F7
      this.next();
      event.stopPropagation();
      event.preventDefault();
    }
  }

  toggleListening (song = null, track = null, listen = true) {
    const callback = track ? listen ? this.listen : this.pause : null;
    this.setState({
      current: {
        song,
        track,
        collapsed: song,
        inProgress: false,
        progress: 0,
        duration: 0
      }
    }, callback);
  }

  replay (song, track = null) {
    if (!track) {
      let updatedDictation = this.state.dictation.slice(0);
      updatedDictation[song - 2] = updatedDictation[song - 2].map(chunk => {
        delete chunk.progress;
        delete chunk.duration;
        return chunk;
      });
      track = updatedDictation[song - 2][0];
    }

    this.setState({
      current: {
        song,
        track,
        collapsed: song,
        inProgress: false,
        progress: 0,
        duration: 0
      }
    }, track ? this.listen : null);
  }

  onCollapse (song) {
    this.setState(prevState => ({
      current: {
        ...prevState.current,
        collapsed: song
      }
    }));
  }

  onLoadedMetadata(event) {
    if (!this.state.current || !this.state.current.track) return;

    let updatedDictation = this.state.dictation.slice(0);

    if (this.state.current.track.type === "dictation") {
      updatedDictation[this.state.current.track.sentence - 1][this.state.current.track.chunk - 1] = {
        ...updatedDictation[this.state.current.track.sentence - 1][this.state.current.track.chunk - 1],
        duration: event.target.duration || 0
      }
    } else {
      const state = { ...this.state };
            state[this.state.current.track.type].duration = event.target.duration || 0;
      this.setState(state);
    }

    this.setState(prevState => ({
      current: {
        ...prevState.current,
        duration: event.target.duration || 0
      },
      dictation: updatedDictation
    }));
  }

  onPlay (event) {
    this.setState(prevState => ({
      current: {
        ...prevState.current,
        inProgress: true
      }
    }));
  }

  onListen (progress) {
    let updatedDictation = this.state.dictation.slice(0);

    this.setState(prevState => {
      if (this.state.current.track.chunk) {
        updatedDictation[this.state.current.track.sentence - 1][this.state.current.track.chunk - 1] = {
          ...updatedDictation[this.state.current.track.sentence - 1][this.state.current.track.chunk - 1],
          progress
        }

        prevState.dictation = updatedDictation;
      } else {
        prevState[this.state.current.track.type].progress = progress;
      }

      prevState.current = {
        ...prevState.current,
        progress
      }

      return prevState;
    });
  }

  onEnded (event) {
    this.setState(prevState => {
      if (this.state.current.track.chunk) {
        let updatedDictation = this.state.dictation.slice(0);
        updatedDictation[this.state.current.track.sentence - 1][this.state.current.track.chunk - 1] = {
          ...updatedDictation[this.state.current.track.sentence - 1][this.state.current.track.chunk - 1],
          progress: event.target.duration
        }

        prevState.dictation = updatedDictation;
      } else {
        prevState[this.state.current.track.type].progress = event.target.duration;
      }

      prevState.current = {
        ...prevState.current,
        progress: event.target.duration,
        inProgress: false,
      };

      return prevState;
    });
  }

  listen () {
    if (this.refs.player.rap) {
      if (window.domEditor) window.domEditor.focus();

      if (this.state.current.track.type !== "dictation" && this.state[this.state.current.track.type].progress)
        this.setCurrentTime(this.state[this.state.current.track.type].progress);
      const playPromise = this.refs.player.rap.audioEl.current.play();

      // Prevent The play() request was interrupted error
      if (playPromise != undefined) {
        playPromise.then(_ => {})
        .catch(_ => {});
      }

      this.setState(prevState => ({
        current: {
          ...prevState.current,
          inProgress: true
        }
      }));
    }
  }

  play () {
    if (this.state.current.track && this.state.current.progress < this.state.current.duration) {
      this.listen();
    } else {
      this.next();
    }
  }

  playPause() {
    if (this.state.current.inProgress) {
      this.pause();
    } else {
      this.play();
    }
  }

  next () {
    if (!this.state.current.track  || this.state.current.track.type === "first_reading") {
      this.toggleListening(2, this.state.dictation[0][0]);
    } else if (this.state.current.track.type === "proof_reading") {
      this.setCurrentTime(0);
    } else {
      let sentence = this.state.current.track.sentence - 1;
      let tracks = this.state.dictation[sentence];
      let nextTrack = tracks.find(track => track.chunk == this.state.current.track.chunk + 1);

      if (!nextTrack) {
        sentence = sentence + 1;
        tracks = this.state.dictation[sentence];
        if (tracks) nextTrack = tracks[0]
      }

      if (nextTrack) { // Continue dictation
        this.toggleListening(sentence + 2, nextTrack);
      } else if (this.state.proof_reading) { // Proof reading
        this.toggleListening(this.state.dictation.length + 2, this.state.proof_reading);
      }
    }
  }

  prev () {
    if (this.state.current.song) {
      if (this.state.current.track.type === "proof_reading") { // If proof dictation -> take last dictation
        const tracks = this.state.dictation[this.state.dictation.length - 1];
        const track = tracks[tracks.length - 1];

        this.toggleListening(this.state.current.song - 1, track);
      } else if (this.state.current.track.type === "first_reading") { // If first dictation -> set current time
        this.setCurrentTime(0);
      } else if (this.state.current.track.sentence == 1 && this.state.current.track.chunk == 1) { // If first dictation
        this.toggleListening(1, this.state.first_reading);
      } else { // Get prev dictation
        const tracks = this.state.dictation[this.state.current.track.sentence - 1];
        const prevTrack = tracks.find(track => track.chunk == this.state.current.track.chunk - 1);
        if (prevTrack) {
          this.toggleListening(this.state.current.song, prevTrack);
        } else {
          const tracks = this.state.dictation[this.state.current.track.sentence - 2];
          const prevTrack = tracks[tracks.length - 1]

          this.toggleListening(this.state.current.song  - 1, prevTrack);
        }
      }
    }
  }

  pause () {
    if (this.refs.player.rap) {
      this.refs.player.rap.audioEl.current.pause();
      this.setState(prevState => ({
        current: {
          ...prevState.current,
          inProgress: false
        }
      }));
    }
  }

  setCurrentTime (time) {
    if (this.refs.player.rap) {
      this.refs.player.rap.audioEl.current.currentTime = time;
    }
  }

  isInProgress = () => this.state.current.inProgress;

  getNextSong () {
    return this.state.dictation.findIndex(tracks => tracks.find(track => !track.duration || !track.progress || (track.progress < track.duration && this.state.current.track.chunk < track.chunk && this.state.current.track.sentence < track.sentence))) + 1;
  }

  getNextTrack (index) {
    return this.state.dictation[index - 1].find(track => !track.duration || !track.progress || (track.progress < track.duration && this.state.current.track.chunk < track.chunk && this.state.current.track.sentence < track.sentence));
  };

  render() {
    let index = 1;
    return (
      <div ref="playlist">
        <div className="text-center pt-1 md:pt-2 flex md:block justify-between items-center">
          <div className="inline-block align-middle js-tooltip">
            <button type="button" className="text-grey w-12 h-12 md:h-16 rounded-full pt-4 md:pt-0 mr-2 md:mx-2 text-2xl md:text-3xl transition duration-100 transform origin-center md:hover:scale-125 md:hover:text-white" onClick={() => this.prev()}>
              <i className="fas fa-arrow-to-left" />
            </button>
          </div>
          <div className="js-tooltip-element font-bold">
            Morceau précédent
            <div className="js-tooltip-arrow" data-popper-arrow></div>
          </div>
          <div className="inline-block align-middle js-tooltip">
            <button type="button" className="bg-success text-white h-10 px-4 md:px-0 md:w-16 md:h-16 rounded-full text-md md:text-2xl transition duration-100 transform origin-center md:hover:scale-125" onClick={() => this.isInProgress() ? this.pause() : this.play()}>
              <i className={`fas fa-${this.isInProgress() ? 'pause' : 'play'} inline-block align-middle`} /> <span className="inline-block md:hidden ml-1 font-semibold">{this.isInProgress() ? "Pause" : "Lire le texte"}</span>
            </button>
          </div>
          <div className="js-tooltip-element font-bold">
            Lecture
            <div className="js-tooltip-arrow" data-popper-arrow></div>
          </div>
          <div className="inline-block align-middle js-tooltip">
            <button type="button" className="text-grey w-12 h-12 md:h-16 rounded-full pt-4 md:pt-0 ml-2 md:mx-2 text-2xl md:text-3xl transition duration-100 transform origin-center md:hover:scale-125 md:hover:text-white" onClick={() => this.next()}>
              <i className="fas fa-arrow-to-right" />
            </button>
          </div>
          <div className="js-tooltip-element font-bold">
            Morceau suivant
            <div className="js-tooltip-arrow" data-popper-arrow></div>
          </div>
        </div>
        <ul className="playlist-song pt-4 px-2 md:px-0 md:pt-6">
          { this.props.first_reading && (
            <Song toggleListening={this.toggleListening} replay={this.replay} current={this.state.current} key={`song-${index}`} index={index} track={this.state.first_reading} setCurrentTime={this.setCurrentTime}>Écouter la dictée en entier <span className="text-sm text-grey">(recommandé)</span></Song>
          ) }
          { this.state.dictation.map((chunks) => {
              index++;
              return (
                <Song toggleListening={this.toggleListening} replay={this.replay} onCollapse={this.onCollapse} current={this.state.current} key={`song-${index}`} index={index} tracks={chunks}>Phrase n°{index-1}</Song>
              );
            })
          }
          { this.props.proof_reading && (
            <Song toggleListening={this.toggleListening} replay={this.replay} current={this.state.current} key={`song-${index+1}`} index={index+1} track={this.state.proof_reading} setCurrentTime={this.setCurrentTime}>Relire la dictée en entier <span className="text-sm text-grey">(recommandé)</span></Song>
          ) }
        </ul>
        <Player ref="player" state={this.state.current} onLoadedMetadata={this.onLoadedMetadata} onPlay={this.onPlay} onListen={this.onListen} onEnded={this.onEnded}  />
      </div>
    );
  }
}

Playlist.propTypes = {
  dictation: PropTypes.array.isRequired,
  first_reading: PropTypes.object,
  proof_reading: PropTypes.object
};

Playlist.defaultProps = {
  dictation: []
};

export default Playlist;
